import { formatLocale } from "../i18n";
// "Aug 13, 5:42 PM" — date and time joined by hand. iOS WebKit and Chrome
// disagree on the joiner when a single toLocaleString call renders both
// ("Jul 16 at 11:36 AM" vs "Jul 16, 11:36 AM"), so a row would read
// differently in the app than on the web. Empty or invalid input → "".
export function formatWhen(iso?: string | null): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  const day = d.toLocaleDateString(formatLocale(), { month: "short", day: "numeric" });
  const time = d.toLocaleTimeString(formatLocale(), { hour: "numeric", minute: "2-digit" });
  return `${day}, ${time}`;
}
